module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "总览",
      "name": "all"
    }
  }, [_c('total-view')], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "交易记录",
      "name": "transactionRecord"
    }
  }, [_c('transaction-record', {
    attrs: {
      "get-status": _vm.trade
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "储值面额",
      "name": "storedValue"
    }
  }, [_c('stored-value', {
    attrs: {
      "get-status": _vm.rechargeRule
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "充值协议",
      "name": "rechargeAgreement"
    }
  }, [_c('recharge-agreement', {
    attrs: {
      "get-status": _vm.rechargeAgreement
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "充值送积分翻倍",
      "name": "rechargeMultiple"
    }
  }, [_c('recharge-multiple', {
    attrs: {
      "get-status": _vm.rechargeMultiple
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0602a516", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0602a516"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/storeddeposit/index.vue
// module id = 2439
// module chunks = 0